import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import AudienceSplit from "@/components/AudienceSplit";
import FrictionReducers from "@/components/FrictionReducers";

import Teambuilding from "@/components/Teambuilding";
import Experiences from "@/components/Experiences";
import About from "@/components/About";
import GoogleReviews from "@/components/GoogleReviews";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import ChatBot from "@/components/ChatBot";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      <main>
        <Hero />
        <FrictionReducers />
        <AudienceSplit />
        <Teambuilding />
        <GoogleReviews />
        
        <Experiences />
        <About />
        <Contact />
      </main>
      <Footer />
      <ChatBot />
      <FloatingWhatsApp />
    </div>

  );
};

export default Index;

